import { useState } from 'react';
import { Video } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Renders an animated <video> for AI video outputs, falls back to gradient placeholder.
 * Pauses on mount, plays on hover to save bandwidth.
 */
export default function VideoThumbnail({ path, title, autoplay = false, className = '' }) {
  const [errored, setErrored] = useState(false);
  const [hover, setHover] = useState(false);

  if (errored || !path) {
    return (
      <div className={`bg-gradient-to-br from-[#E040A0]/30 to-[#4A7CFF]/30 flex items-center justify-center ${className}`} data-testid="video-fallback">
        <Video className="w-10 h-10 text-white/40" />
      </div>
    );
  }

  return (
    <video
      src={`${API}/files/${path}`}
      title={title}
      muted
      loop
      playsInline
      autoPlay={autoplay || hover}
      preload="metadata"
      onMouseEnter={(e) => { setHover(true); e.currentTarget.play().catch(() => {}); }}
      onMouseLeave={(e) => { setHover(false); if (!autoplay) e.currentTarget.pause(); }}
      onError={() => setErrored(true)}
      className={`object-cover ${className}`}
      data-testid="video-thumb"
    />
  );
}
